var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"staking-bg"}),_c('div',{staticClass:"staking-bg-squishies"}),_c('StakingHero'),_c('StakingSelection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }